import {UltimeNovitaView} from "./ultime-novita.view";
export default UltimeNovitaView;
